import React from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Search, Download, Upload } from "lucide-react";

export default function LeadFilters({
  q, setQ,
  statusFilter, setStatusFilter, statusOptions,
  hasilAkhirFilter, setHasilAkhirFilter,
  adminFilter, setAdminFilter, adminUsers,
  dateFrom, setDateFrom,
  dateTo, setDateTo,
  isManager,
  total,
  onApply,
  onReset,
  onExport,
  onImport,
}) {
  const hasActiveFilter =
    q || statusFilter !== "all" || hasilAkhirFilter !== "all" || adminFilter !== "all" || dateFrom || dateTo;

  return (
    <Card className="bg-[#121212] border-border p-4 rounded-md mb-4">
      <div className="grid grid-cols-1 md:grid-cols-7 gap-3 items-end">
        <div className="md:col-span-2">
          <label className="text-[10px] tracking-[0.2em] uppercase text-muted-foreground block mb-1.5">Search</label>
          <div className="relative">
            <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" strokeWidth={1.5} />
            <Input
              data-testid="leads-search-input"
              value={q}
              onChange={(e) => setQ(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && onApply()}
              placeholder="Name, NAC, NIM, phone..."
              className="pl-9 bg-[#0A0A0A] border-border h-9"
            />
          </div>
        </div>
        <div>
          <label className="text-[10px] tracking-[0.2em] uppercase text-muted-foreground block mb-1.5">Status</label>
          <Select value={statusFilter} onValueChange={setStatusFilter}>
            <SelectTrigger data-testid="filter-status" className="bg-[#0A0A0A] border-border h-9">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All statuses</SelectItem>
              {statusOptions.map((s) => (
                <SelectItem key={s} value={s}>{s}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div>
          <label className="text-[10px] tracking-[0.2em] uppercase text-muted-foreground block mb-1.5">Hasil Akhir</label>
          <Select value={hasilAkhirFilter} onValueChange={setHasilAkhirFilter}>
            <SelectTrigger data-testid="filter-hasil-akhir" className="bg-[#0A0A0A] border-border h-9">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Semua hasil</SelectItem>
              <SelectItem value="selesai">Terproses</SelectItem>
              <SelectItem value="progress">On Proses</SelectItem>
              <SelectItem value="belum">Belum</SelectItem>
            </SelectContent>
          </Select>
        </div>
        {isManager && (
          <div>
            <label className="text-[10px] tracking-[0.2em] uppercase text-muted-foreground block mb-1.5">Admin</label>
            <Select value={adminFilter} onValueChange={setAdminFilter}>
              <SelectTrigger data-testid="filter-admin" className="bg-[#0A0A0A] border-border h-9">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All admins</SelectItem>
                <SelectItem value="__unassigned">Unassigned</SelectItem>
                {adminUsers.map((a) => (
                  <SelectItem key={a.id} value={a.id}>{a.name}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        )}
        <div>
          <label className="text-[10px] tracking-[0.2em] uppercase text-muted-foreground block mb-1.5">From</label>
          <Input type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} className="bg-[#0A0A0A] border-border h-9" />
        </div>
        <div>
          <label className="text-[10px] tracking-[0.2em] uppercase text-muted-foreground block mb-1.5">To</label>
          <Input type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} className="bg-[#0A0A0A] border-border h-9" />
        </div>
      </div>
      <div className="flex items-center justify-between gap-3 mt-4 pt-4 border-t border-border">
        <div className="flex items-center gap-2 text-xs text-muted-foreground font-mono">
          <span>{total} results</span>
          {hasActiveFilter && (
            <button onClick={onReset} className="text-primary hover:underline">Reset</button>
          )}
        </div>
        <div className="flex gap-2">
          <Button onClick={onApply} variant="outline" size="sm" className="border-border bg-transparent">
            Apply
          </Button>
          <Button data-testid="export-excel-button" onClick={() => onExport("xlsx")} variant="outline" size="sm" className="border-border bg-transparent text-foreground hover:bg-[#1C1C1E]">
            <Download className="w-3.5 h-3.5 mr-1.5 text-[#32D74B]" strokeWidth={1.5} />
            Export Excel
          </Button>
          {isManager && (
            <>
              <Button data-testid="export-button" onClick={() => onExport("csv")} variant="outline" size="sm" className="border-border bg-transparent">
                <Download className="w-3.5 h-3.5 mr-1.5" strokeWidth={1.5} />
                Export CSV
              </Button>
              <label className="cursor-pointer">
                <input type="file" accept=".csv,.xlsx,.xls" onChange={onImport} className="hidden" data-testid="import-input" />
                <span className="inline-flex items-center h-9 px-3 text-sm rounded-md border border-border bg-transparent hover:bg-[#1C1C1E] transition-colors">
                  <Upload className="w-3.5 h-3.5 mr-1.5" strokeWidth={1.5} />
                  Import
                </span>
              </label>
            </>
          )}
        </div>
      </div>
    </Card>
  );
}
